<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="header">
                        <h4 class="title"></h4>
                        <p class="category"></p>
                    </div>

                    <div class="text-right">
                        <i [routerLink]="['/app/newemailtemplate']" class="material-icons">add</i>
                    </div>
                    <div class="container-fluid">
                        <div class="table-responsive">
                            <table id="table" class="table table-striped " cellspacing="0" width="100%">
                                <thead>
                                    <tr>
                                        <th *ngFor="let header of tableHeaders">{{header}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!--*ngFor="let row of data; let i = index"-->
                                    <tr>
                                        <td>My Invitation email</td>
                                        <td>Invitation</td>
                                        <td>Regular</td>
                                        <td>General</td>
                                        <td>
                                            <i class="material-icons">edit</i>
                                            <i class="material-icons">delete</i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>My Reminder email v1.0</td>
                                        <td>Reminder</td>
                                        <td>Regular</td>
                                        <td>General</td>
                                        <td>
                                            <i class="material-icons">edit</i>
                                            <i class="material-icons">delete</i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>My 360 result email v1.0</td>
                                        <td>Result</td>
                                        <td>360</td>
                                        <td>Sports</td>
                                        <td>
                                            <i class="material-icons">edit</i>
                                            <i class="material-icons">delete</i>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
